import "../../assets/styles/styles.css"
import "./lobby.css";

import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import nakamaUtilInstance, { user, client, session, socketConnected, socket, sessionTimeoutCheck, joinLobbyStream, getSessionExpiryTime, extendSession } from '../../utils/nakama';
import opCodes from '../../constants/opCodes.jsx';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import pandaPfp from "../../assets/images/panda_pfp.png"
import bonezIcon from '../../assets/images/bonez_icon.svg'
import leaveGameButton from '../../assets/images/leave_game_button.png'
import dailybonusimage from "../../assets/images/bonez_mystery_bag.png";
import ImageFader from "./components/ImageFader.jsx";

import { Button, Collapse, Image, Toast, ToastContainer, Offcanvas, Container, Row, Col, Modal, Navbar, Overlay, Form } from "react-bootstrap";

import CreateGameModal from './components/CreateGameModal.jsx';
import CreateShopModal from './components/ChipzShop.jsx';
import OpenDeckBuilderModal from "./components/openDeckBuilderModal";
import MatchTerminatedModal from "./components/matchTerminatedModal";
import ForfeitPenaltyModal from './components/ForfeitPenaltyModal';
import InviteNav from "./components/InviteNav";
import LobbyTable from './components/LobbyTable.jsx';
import ChatRoom from './components/ChatRoom';
import PwaModal from '../../components/PwaModal'
import WelcomeModal from "./components/WelcomeModal";
import SessionExpiryModal from "./components/SessionExpiryModal";
import LandscapeModal from "../../components/LandscapeModal";
import { playSound, handleClickSound } from "../game/scenes/classes/PlaySound";
import CreateSuccessModal from "./components/PurchaseSuccess";
import Shop from "./components/Shop";
import DailyBonusPhaser from "./components/DailyBonusPhaser.jsx";

import InfoNav from "./components/InfoNav";
import CardNav from "./components/CardsPack";
import Insufficientcoin from "./components/Insufficientcoin";
import Insufficientbonez from "./components/Insufficientbonez";
import InsufficientChipzJoinModal from "./components/InsufficientChipzJoinModal";

import settingsIcon from '../../assets/images/settings_icon.png'
import heartIcon from '../../assets/images/heart_icon.png'
import infoIcon from '../../assets/images/info_icon.png'
import shopIcon from '../../assets/images/shop_icon.png'
import shopnavicon2 from '../../assets/images/power_card_box.webp'
import metamaskIcon from '../../assets/images/metamask_icon.svg'
// import mostpopular from '../../assets/images/most_popular.png'
// import vipIcon from '../../assets/images/gold_vip_icon.png'
import xpIcon from '../../assets/images/xp.png'
import eventsCenter, { PHASER_EVENTS } from "../../utils/phaserEvents.js";
import LobbyList from "./components/LobbyList.jsx";
import { requestNotificationPermission, registerServiceWorkerListener } from "../../utils/firebase";
import NotificationPopover from "./components/NotificationPopover.jsx";
import FeedbackForm from "../../components/FeedbackForm.jsx";
import ServerNotifications from './components/ServerNotifications';

export default function Lobby({ currentScreen, setCurrentScreen, setMatchId, opCodeData, setOpCodeData }) {


    const [profilePicture, setProfilePicture] = useState("")
    const [walletId, setWalletId] = useState("");
    // Initialize with safe defaults to prevent race condition errors
    const [userLevels, setUserLevels] = useState({ level: 1, xp: 0, bone: 0 });
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showShopModal, setShowShopModal] = useState(false);
    const [showSucessModal, setShowSuccessModal] = useState(false);
    const [successPackage, setSuccessPackage] = useState("");
    const [showMatchTerminatedModal, setShowMatchTerminatedModal] = useState(false);
    const [wagerType, setWagerType] = useState("zoom");
    const [potAmount, setPotAmount] = useState(10000);
    const [onlineFriendsCount, setOnlineFriendsCount] = useState(0);
    const [leaveChat, setLeaveChat] = useState(false);
    const [joinChat, setJoinChat] = useState(false);
    const [isLoadingMatches, setIsLoadingMatches] = useState(false);
    const [gamesCreated, setGamesCreated] = useState(0);
    const [loadedUserData, setLoadedUserData] = useState(false); //used to force the useEffect to update until user information can be loaded
    // Initialize with safe default to prevent race condition errors
    const [zoomBalance, setZoomBalance] = useState(0);
    const [isCancelling, setIsCancelling] = useState([]);
    const [showMatchAnnouncement, setShowMatchAnnouncement] = useState(false);
    const [showLobbyList, setShowLobbyList] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [showWelcomeModal, setShowWelcomeModal] = useState(false);
    const [showForfeitPenaltyModal, setShowForfeitPenaltyModal] = useState(false);

    // Session expiry modal state
    const [showSessionExpiryModal, setShowSessionExpiryModal] = useState(false);
    const [sessionMinutesRemaining, setSessionMinutesRemaining] = useState(null);
    const [sessionWarningDismissed, setSessionWarningDismissed] = useState(false);
    const [isExtendingSession, setIsExtendingSession] = useState(false);

    const setParentNotifications = (bool) => {
        setNotifications(bool);
    }
    const [friendRequestPending, setFriendRequestPending] = useState(false); //for chatroom notification icon
    const [boneReady, setBoneReady] = useState(false); //for chatroom notification icon

    const [isFullScreen, setIsFullScreen] = useState(false);
    /*const setGamesCreated = (update) => {
        gamesCreated.current = update;
    }*/
    const [isShowingPwaModal, setIsShowingPwaModal] = useState(false);
    const [isShowingIOSModal, setIsShowingIOSModal] = useState(false);
    const [isShowingLandscapeModal, setIsShowingLandscapeModal] = useState(false);
    const [isLoadSceneVisible, setIsLoadSceneVisible] = useState(false);

    const [pwaDownloaded, setPwaDownloaded] = useState(false)
    const [isChrome, setIsChrome] = useState(false);
    const [isSafari, setIsSafari] = useState(false);
    const [isOtherAndroid, setIsOtherAndroid] = useState(false);
    const location = useLocation();

    const sidebarRef = useRef(null);
    const shopButtonRef = useRef(null);
    const inviteButtonRef = useRef(null);
    const settingsButtonRef = useRef(null);
    const infoButtonRef = useRef(null);
    const chipzButtonRef = useRef(null);
    const lobbyListRef = useRef(null);

    const [isShopBarActive, setIsShopBarActive] = useState(false);
    const [isInviteBarActive, setIsInviteBarActive] = useState(false);
    const [isSettingsBarActive, setIsSettingsBarActive] = useState(false);
    const [isInfoBarActive, setIsInfoBarActive] = useState(false);

    const LOCAL_STORAGE_MUSIC_VOLUME = 'musicVolume';
    const LOCAL_STORAGE_SOUND_VOLUME = 'soundVolume';

    // fetching values from local storage or use default values
    const musicVolumeFromStorage = localStorage.getItem(LOCAL_STORAGE_MUSIC_VOLUME);
    const soundVolumeFromStorage = localStorage.getItem(LOCAL_STORAGE_SOUND_VOLUME);

    const initialMusicVolume = musicVolumeFromStorage !== null ? +musicVolumeFromStorage : 12.5;
    const initialSoundVolume = soundVolumeFromStorage !== null ? +soundVolumeFromStorage : 12.5;

    const [musicVolume, setMusicVolume] = useState(initialMusicVolume);
    const [soundVolume, setSoundVolume] = useState(initialSoundVolume);

    const musicSliderBackground = {
        background: `linear-gradient(90deg, #00D1FF 0%, #00D1FF ${musicVolume}%, #5A4F71 ${musicVolume}%, #5A4F71 100%)`
    };
    const soundSliderBackground = {
        background: `linear-gradient(90deg, #00D1FF 0%, #00D1FF ${soundVolume}%, #5A4F71 ${soundVolume}%, #5A4F71 100%)`
    };

    const [showToast, setShowToast] = useState(false);
    const [showCannotJoinMatchToast, setCannotJoinMatchToast] = useState(false);
    const [showTournamentToast, setShowTournamentToast] = useState(false);
    const [tournamentEndedText, setTournamentEndedText] = useState("Loading..");
    const [boneActionUsername, setBoneActionUsername] = useState("");
    const [boneAction, setBoneAction] = useState("");
    const [showBoneToast, setShowBoneToast] = useState(false);
    const [showMatchResultToast, setShowMatchResultToast] = useState(false);
    const [matchResultText, setMatchResultText] = useState("");
    const [showRewardAnimation, setShowRewardAnimation] = useState(false);
    const [rewardAmount, setRewardAmount] = useState(0);
    const [rewardCurrency, setRewardCurrency] = useState("bone"); // "bone" or "chipz"

    const [isShopActive, setIsShopActive] = useState(true);
    const [isCoinActive, setIsCoinActive] = useState(false);
    const [isBonezActive, setIsBonezActive] = useState(false);
    const [isBalanceUpdated, setBalanceUpdated] = useState(false);
    const [showDailyReward, setShowDailyReward] = useState(false);

    const [penalizedOpponents, setPenalizedOpponents] = useState([]);
    const [showInsufficientChipzModal, setShowInsufficientChipzModal] = useState(false);
    const [requiredChipzAmount, setRequiredChipzAmount] = useState(0);
    const [insufficientWagerType, setInsufficientWagerType] = useState("zoom");

    const redirectToBridge = () => {
        console.log("redirecting to bridge");
        window.location.href = "https://zoombies.world/auth/bridge";
    }

    const closeShopNav = () => {
        setIsShopBarActive(false);
        setTimeout(() => {
            setIsShopActive(true);
            setIsCoinActive(false);
            setIsBonezActive(false);
        }, 1000);
    }

    const formatTime = (milliseconds) => {
        let seconds = Math.floor((milliseconds / 1000) % 60);
        let minutes = Math.floor((milliseconds / (1000 * 60)) % 60);
        let hours = Math.floor((milliseconds / (1000 * 60 * 60)) % 24);

        hours = (hours < 10) ? "0" + hours : hours;
        minutes = (minutes < 10) ? "0" + minutes : minutes;
        seconds = (seconds < 10) ? "0" + seconds : seconds;
        return hours + ":" + minutes + ":" + seconds;
    }

    const getDailyRewardStatus = async () => {
        try {
            if (!client || !session) {
                console.log("Client or session not initialized, skipping daily reward check");
                return;
            }
            const res = await client.rpc(session, "checkdailyreward", { "request": "getStatus" });
            // Now set the navbar icon state
            if (res.payload.serverTime >= res.payload.nextReward) { //Collect
                //Play sound
                playSound("dailyRewardSound");
                setDailyRewardTimeLabel("Collect!");
                setShowDailyBonusModal(true);
            } else { //show timer
                //Format time
                nextRewardTime.current = parseInt(res.payload.nextReward) - parseInt(res.payload.serverTime);
                rewardTimer.current = setInterval(() => {
                    nextRewardTime.current = nextRewardTime.current - 1000;
                    if (nextRewardTime.current <= 0) { //when time runs, collect is ready
                        clearInterval(rewardTimer.current);
                        setDailyRewardTimeLabel("Collect!");
                        return;
                    }
                    // console.log("nextRewardTime: ", nextRewardTime.current);
                    let newTimeLabel = formatTime(nextRewardTime.current);
                    setDailyRewardTimeLabel(newTimeLabel);
                }, 1000);
                return () => clearInterval(rewardTimer.current);
            }
        } catch (error) {
            console.error("Failed to fetch daily reward status: ", error);
        }
    }

    //Setup Daily Reward State
    const [showDailyBonusModal, setShowDailyBonusModal] = useState(false);
    const nextRewardTime = useRef(0);
    const rewardTimer = useRef(null);
    const [dailyRewardTimeLabel, setDailyRewardTimeLabel] = useState("0");

    //Mobile check for PWA and landscape mode
    useEffect(() => {
        registerServiceWorkerListener();
        const setupPWAandDailyReward = async () => {
            //Check daily reward so modal is underneath
            if (nextRewardTime.current > 0) {
                return;
            }
            await getDailyRewardStatus();

            const userAgent = navigator.userAgent || navigator.vendor || window.opera;

            // Check for IOS devices
            const iosMatch = userAgent.match(/(iPad|iPhone|iPod).*OS (\d+)_?/);
            const isIOS = !!iosMatch;
            const iOSVersion = isIOS ? parseInt(iosMatch[2], 10) : null;

            const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent);
            const isAndroid = /Android/i.test(navigator.userAgent);
            const isSafari = isMobile && /safari/i.test(navigator.userAgent) && !/chrome|crios/i.test(navigator.userAgent);
            const isChrome = isMobile && /chrome|crios/i.test(navigator.userAgent) && !/edge|edg\//i.test(navigator.userAgent);
            const isOtherAndroidBrowser = isAndroid && !isChrome && !isSafari;

            // Web platform check
            if (isSafari) {
                // Mobile Safari browser is used
                setIsSafari(true)
                setIsChrome(false)
                setIsOtherAndroid(false)
                setPwaDownloaded(false)
                setIsShowingPwaModal(true)
            } else if (isChrome) {
                // Chrome browser is used
                setIsChrome(true)
                setIsSafari(false)
                setIsOtherAndroid(false)
                setPwaDownloaded(false)
                setIsShowingPwaModal(true)
            } else if (isOtherAndroidBrowser) {
                // Other Android browser (MIUI, Samsung, etc.)
                setIsOtherAndroid(true)
                setIsChrome(false)
                setIsSafari(false)
                setPwaDownloaded(false)
                setIsShowingPwaModal(true)
            }

            const mqStandAlone = '(display-mode: fullscreen)';
            if (window.matchMedia(mqStandAlone).matches) {
                setIsShowingPwaModal(false)
                setPwaDownloaded(true);

                // IOS version check
                if (isIOS && iOSVersion && iOSVersion < 17) {
                    alert('WARNING: Your device is running an older version of iOS. Please update to iOS 17 or higher to play Zoombies Bonez, the game will NOT function.');
                }
            }
        }
        setupPWAandDailyReward();

        // Always try to join lobby stream
        // DEBUG: Socket connection
        // console.log("🔍 Attempting to join lobby stream...");
        joinLobbyStream();

        // Listen for socket connection/reconnection events to rejoin stream
        const onSocketConnected = () => {
            // console.log("🔌 Socket connected event received in Lobby, joining stream...");
            joinLobbyStream();
        };

        eventsCenter.on(PHASER_EVENTS.SOCKET_CONNECTED, onSocketConnected);
        eventsCenter.on(PHASER_EVENTS.SOCKET_RECONNECTED, onSocketConnected);

        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                console.log("👁️ App came to foreground, refreshing lobby stream...");
                joinLobbyStream();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            eventsCenter.off(PHASER_EVENTS.SOCKET_CONNECTED, onSocketConnected);
            eventsCenter.off(PHASER_EVENTS.SOCKET_RECONNECTED, onSocketConnected);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [])

    const showShopNav = () => setIsShopBarActive(true);

    const toggleShopContent = () => {
        setIsShopActive(!isShopActive);
    };

    const toggleCoinContent = () => {
        setIsCoinActive(!isCoinActive);
    };
    const toggleBalanceUpdated = () => {
        setBalanceUpdated(!isBalanceUpdated);
    };

    const toggleBonezContent = () => {
        setIsBonezActive(!isBonezActive);
    };

    const toggleInviteContent = () => {
        setIsInviteBarActive(!isInviteBarActive);
    }

    const handleCoin = () => {
        setIsShopBarActive(true);
        setIsShopActive(false);
    }

    useEffect(() => {
        const musicElements = document.querySelectorAll(".music");
        const soundElements = document.querySelectorAll(".sound-fx");

        musicElements.forEach(element => {
            element.volume = musicVolume / 100;
        });

        soundElements.forEach(element => {
            element.volume = soundVolume / 100;
        });
    }, [musicVolume, soundVolume]);

    // Update local storage when volumes change
    useEffect(() => {
        localStorage.setItem(LOCAL_STORAGE_MUSIC_VOLUME, musicVolume);
        localStorage.setItem(LOCAL_STORAGE_SOUND_VOLUME, soundVolume);
    }, [musicVolume, soundVolume]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target) && !settingsButtonRef.current.contains(event.target)) {
                setIsSettingsBarActive(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [sidebarRef]);

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const stripeSuccessValue = urlParams.get('stripesuccess');

        if (stripeSuccessValue) {
            const value = parseInt(stripeSuccessValue, 10);

            if (!isNaN(value)) {
                setShowSuccessModal(true);
                setSuccessPackage(value);
            }
        }
    }, [successPackage])

    useEffect(() => {
        if (window.innerHeight > window.innerWidth) {
            setIsShowingLandscapeModal(true)
        } else {
            setIsShowingLandscapeModal(false)
        }
    }, [window.innerHeight, window.innerWidth])

    // Session expiry monitoring - warns user at 5 minutes and 1 minute before expiry
    useEffect(() => {
        const checkSessionExpiry = () => {
            const expiryTime = getSessionExpiryTime();
            if (!expiryTime) return;

            const now = Date.now();
            const timeRemaining = expiryTime - now;
            const minutesRemaining = Math.floor(timeRemaining / 60000);

            // Session expired - redirect immediately (don't show modal if expired)
            if (timeRemaining <= 0) {
                console.log("Session expired, redirecting to auth");
                setShowSessionExpiryModal(false); // Close modal if open
                window.location.href = "https://zoombies.world/auth/?returnTo=" + window.location.href;
                return;
            }

            // Don't show modal if we're currently extending the session
            if (isExtendingSession) {
                return;
            }

            // 5 minute warning (first warning)
            if (minutesRemaining <= 5 && minutesRemaining > 0 && !sessionWarningDismissed && !showSessionExpiryModal) {
                setSessionMinutesRemaining(minutesRemaining);
                setShowSessionExpiryModal(true);
            }
            // 1 minute warning (final warning after dismiss)
            else if (minutesRemaining <= 1 && minutesRemaining > 0 && sessionWarningDismissed && !showSessionExpiryModal) {
                setSessionMinutesRemaining(minutesRemaining);
                setShowSessionExpiryModal(true);
                setSessionWarningDismissed(false); // Reset so it shows again if they dismiss
            }
            // Update minutes remaining if modal is showing
            else if (showSessionExpiryModal && minutesRemaining !== sessionMinutesRemaining && minutesRemaining > 0) {
                setSessionMinutesRemaining(minutesRemaining);
            }
        };

        // Check immediately on mount
        checkSessionExpiry();

        // Check every 5 seconds for more responsive expiry detection
        // This ensures we catch session expiry quickly and can redirect promptly
        const intervalId = setInterval(checkSessionExpiry, 5000);

        return () => clearInterval(intervalId);
    }, [sessionWarningDismissed, showSessionExpiryModal, sessionMinutesRemaining, isExtendingSession]);

    // Session expiry modal handlers
    const handleExtendSession = async () => {
        // Prevent multiple simultaneous calls
        if (isExtendingSession) {
            return;
        }

        setIsExtendingSession(true);

        try {
            const success = await extendSession();

            if (success) {
                // Small delay to allow socket to reconnect and settle
                await new Promise(resolve => setTimeout(resolve, 500));

                // Close modal and reset state
                setShowSessionExpiryModal(false);
                setSessionWarningDismissed(false);
                setIsExtendingSession(false);
                addNotification("✅ Session extended successfully!");
            } else {
                // Session refresh failed, redirect to auth
                setIsExtendingSession(false);
                window.location.href = "https://zoombies.world/auth/?returnTo=" + window.location.href;
            }
        } catch (error) {
            console.error("Error extending session:", error);
            setIsExtendingSession(false);
            // Allow user to dismiss even if there's an error
            setShowSessionExpiryModal(false);
            addNotification("⚠️ Session extension had issues. Please try again if problems persist.");
        }
    };

    const handleDismissSessionWarning = () => {
        setShowSessionExpiryModal(false);
        setSessionWarningDismissed(true);
    };

    /* View in fullscreen */
    async function toggleFullscreen() {
        const docElement = document.documentElement;

        function handleFullScreenChange() {
            const isNowFullScreen = document.fullScreenElement ||
                document.webkitFullscreenElement ||
                document.msFullscreenElement;
            setIsFullScreen(!!isNowFullScreen);
        }

        if (!isFullScreen) {
            try {
                // Attempt to use the standard method first
                if (docElement.requestFullscreen) {
                    await docElement.requestFullscreen();
                } else if (docElement.webkitRequestFullscreen) { // Fallback for Safari
                    await docElement.webkitRequestFullscreen();
                } else if (docElement.msRequestFullscreen) { // Fallback for IE11
                    await docElement.msRequestFullscreen();
                }

                // Add event listener for fulll-screen change
                document.addEventListener("fullscreenchange", handleFullScreenChange);
                document.addEventListener("webkitfullscreenchange", handleFullScreenChange);
                document.addEventListener("MSfullscreenchange", handleFullScreenChange);
            } catch (error) {
                console.error("Error attempting to enable full-screen mode:", error);
            }
        } else {
            try {
                // Add event listener for full-screen change
                document.removeEventListener('fullscreenchange', handleFullScreenChange);
                document.removeEventListener('webkitfullscreenchange', handleFullScreenChange);
                document.removeEventListener('MSFullscreenChange', handleFullScreenChange);

                if (document.exitFullscreen) {
                    await document.exitFullscreen();
                } else if (docElement.webkitExitFullscreen) { // Fallback for Safari
                    await docElement.webkitExitFullscreen();
                } else if (docElement.msExitFullscreen) { // Fallback for IE11
                    await docElement.msExitFullscreen();
                }
            } catch (error) {
                console.error("Error attempting to exit full-screen mode:", error);
            }
        }

        setIsFullScreen(!isFullScreen);
    }

    //join chat when lobby loads
    useEffect(() => {
        if (currentScreen === "lobby") {
            setJoinChat(true);
        }
    }, [currentScreen])

    useEffect(() => {
        if (isLoadingMatches) {
            setShowToast(true);
        }
    }, [isLoadingMatches])

    const [createGameOnCooldown, setCreateGameOnCooldown] = useState(false);
    async function createGame() {
        if (createGameOnCooldown) {
            return;
        }
        setCreateGameOnCooldown(true);
        setTimeout(() => {
            setCreateGameOnCooldown(false);
        }, 500)
        setShowCreateModal(false); //moved to top to prevent duplicate requests

        //Update createdGames storage object 
        let createdGames = 0;
        try {
            const matches = await client.rpc(session, "getBonezMatchListing", null);
            //console.log("match log", matches);
            for (var match in matches.payload.availableMatches) {
                if (matches.payload.availableMatches[match] && matches.payload.availableMatches[match].label.hostId === session.user_id.toString()) {
                    createdGames++;
                }
            }
            //console.log("created games 3: ", createdGames)
            setGamesCreated(createdGames => createdGames);
        } catch (error) {
            console.error("Failed to fetch matches: ", error);
            sessionTimeoutCheck();
        }

        //console.log("games created: ", gamesCreated)
        if (gamesCreated < 3 && !isLoadingMatches) {
            const payload = {
                "wagerType": wagerType,
                "potAmount": potAmount
            }

            try {
                const match = await client.rpc(session, "createBonezGame", payload);
                joinMatch(match.payload.matchId);
                setMatchId(match.payload.matchId.toString());
                setIsLoadingMatches(true);
                //updating games created count since server increments this count after creating a game
                setGamesCreated(createdGames => createdGames + 1);
                //console.log("games created: ", gamesCreated)
            } catch (error) {
                console.error("Failed to create game", error)
                sessionTimeoutCheck();
            }
        }
    }

    async function joinMatch(matchId, potAmountMinusFee, wagerType, requiredWager) {
        // Only do balance check if all parameters are provided (for regular match joining)
        if (potAmountMinusFee !== undefined && wagerType !== undefined && requiredWager !== undefined) {
            if (wagerType === "zoom") {
                const currentBalance = zoomBalance || 0;
                if (currentBalance < requiredWager) {
                    setRequiredChipzAmount(requiredWager);
                    setInsufficientWagerType(wagerType);
                    setShowInsufficientChipzModal(true);
                    return;
                }
            }
            else if (wagerType === "bonez") {
                const currentBalance = userLevels?.bone ?? 0;
                if (currentBalance < requiredWager) {
                    setRequiredChipzAmount(requiredWager);
                    setInsufficientWagerType(wagerType);
                    setShowInsufficientChipzModal(true);
                    return;
                }
            }
        }
        try {
            const match = await socket.joinMatch(matchId);
            setMatchId(matchId.toString());

            const parsedLabel = JSON.parse(match.label);
            window.Phaser.potAmount = parsedLabel.potAmount;
            window.Phaser.wagerType = parsedLabel.wagerType;

            // Clear loading state after successful join
            setLoadingSpectate(null);
        } catch (error) {
            // Clear loading state on error
            setLoadingSpectate(null);

            //session has expired
            if (
                (error.code === 4 || error.code === 5) &&
                (error.message === "Match not found" ||
                    error.message === "Spectators may only join after the game has started")
            ) {
                setCannotJoinMatchToast(true);
            } else {
                sessionTimeoutCheck();
            }

            console.error("Failed to fetch matches: ", error);
        }
    }

    async function leaveMatch(matchId) {
        try {
            setIsCancelling(oldArray => [...oldArray, matchId]);
            await socket.leaveMatch(matchId);
            setGamesCreated(gamesCreated => gamesCreated - 1)
            console.log("Left match: ", matchId);
            setPlayer1Data(null);
            setPlayer2Data(null);
        } catch (error) {
            console.error("Failed to leave match: ", error, matchId)
        }
    }

    async function requestBrowserNotificationPermission(enable) {
        if (enable) {
            await requestNotificationPermission();
        } else { //Disable notifications
            await client.rpc(session, "checkAndWriteUserNotifications", { token: "disable" });
        }
    }

    //server side match filtering
    const availableMatchesQuery = useQuery({
        queryKey: ["listMatches"],
        enabled: !!(client && session), // Only run query if client and session are available
        refetchOnMount: true, // Always refetch when component mounts (e.g., returning from a match)
        queryFn: async () => {
            try {
                if (!client || !session) {
                    throw new Error("Client or session not initialized");
                }
                const matches = await client.rpc(session, "getBonezMatchListing", null);
                setIsLoadingMatches(false);
                setIsCancelling([]);
                let createdGames = 0;

                // Check if activeMatches exists and is iterable
                if (matches.payload && matches.payload.activeMatches && Array.isArray(matches.payload.activeMatches)) {
                    for (const match of matches.payload.activeMatches) {
                        if (matches.payload.availableMatches && matches.payload.availableMatches[match] && matches.payload.availableMatches[match].label && matches.payload.availableMatches[match].label.hostId === session.user_id.toString()) {
                            createdGames++;
                        }
                    }
                } else {
                    console.warn("activeMatches is not available or not an array:", matches.payload?.activeMatches);
                }

                setGamesCreated(createdGames => createdGames);
                // Sort available matches by wager descending
                if (matches.payload && matches.payload.availableMatches && Array.isArray(matches.payload.availableMatches)) {
                    matches.payload.availableMatches = matches.payload.availableMatches.sort((a, b) => {
                        const potA = a.label?.potAmount || 0;
                        const potB = b.label?.potAmount || 0;
                        return potB - potA; // Descending order (largest first)
                    });
                }
                return matches;
            } catch (error) {
                //session has expired
                if (
                    (error.code === 4 || error.code === 5) &&
                    (error.message === "Match not found" ||
                        error.message === "Spectators may only join after the game has started")
                ) {
                    console.warn("Failed to fetch matches Error handled: ", error, session);
                    setCannotJoinMatchToast(true);
                } else {
                    console.error("Failed to fetch matches: ", error, session);

                    // Handle different types of errors appropriately
                    if (error.status === 401 || error.code === 16) {
                        console.log("Authentication error in matches fetch, checking session...");
                        // Could call sessionTimeoutCheck() here if needed
                    } else if (error.status === 500 || error.message?.includes('Internal Server Error')) {
                        console.log("Server error in matches fetch, will retry automatically");
                    } else if (error.message?.includes('activeMatches is not iterable')) {
                        console.log("Data structure issue with matches response, server may be returning unexpected format");
                        // Set default empty state
                        setIsLoadingMatches(false);
                        setGamesCreated(0);
                        return { payload: { activeMatches: [], availableMatches: {} } }; // Return empty structure
                    }
                }

                // Re-throw the error so React Query can handle retry logic
                throw error;
            }
        },
        // refetchInterval: 5000, //THIS IS VERY INEFFICIENT. REPLACE WITH BROADCAST LISTENER
    });

    const queryClient = useQueryClient();

    // Transform stream match data to match listing format
    const transformStreamMatchToListingFormat = (streamMatch) => {
        return {
            matchId: streamMatch.matchId,
            authoritative: true,
            size: 1,
            label: {
                gameStatus: streamMatch.gameStatus,
                canSpectate: streamMatch.canSpectate,
                spectatorCount: streamMatch.spectatorCount || 0,
                hostId: streamMatch.hostId,
                hostUsername: streamMatch.hostUsername,
                hostAvatarUrl: streamMatch.hostAvatarUrl || '',
                player2Id: streamMatch.player2Id || '',
                player2Username: streamMatch.player2Username || '',
                player2AvatarUrl: streamMatch.player2AvatarUrl || '',
                potAmount: streamMatch.potAmount,
                tableFee: streamMatch.tableFee,
                wagerType: streamMatch.wagerType
            }
        };
    };

    // Sort available matches descending by wager (potAmount)
    const sortMatchesByWager = (matches) => {
        return [...matches].sort((a, b) => {
            const potA = a.label?.potAmount || 0;
            const potB = b.label?.potAmount || 0;
            return potB - potA; // Descending order (largest first)
        });
    };

    useEffect(() => {
        const handleMatchEvent = (event) => {
            // DEBUG: Lobby match event
            // console.log("LOBBY_MATCH_EVENT received:", event);

            // Update React Query cache directly for instant UI updates
            queryClient.setQueryData(['listMatches'], (oldData) => {
                if (!oldData?.payload) {
                    // console.log("⚠️ No old data to update");
                    return oldData;
                }

                const { availableMatches = [], activeMatches = [] } = oldData.payload;
                const { event: eventType, match } = event;

                // console.log(`📝 Updating cache for ${eventType}:`, match);

                // Transform the stream match to listing format
                const transformedMatch = transformStreamMatchToListingFormat(match);

                if (eventType === 'match_created') {
                    // Add new match to availableMatches if it has a valid matchId
                    if (match.matchId && match.matchId !== '') {
                        const matchExists = availableMatches.some(m => m.matchId === match.matchId);
                        if (!matchExists) {
                            console.log(`➕ Adding new match ${match.matchId}`);
                            return {
                                ...oldData,
                                payload: {
                                    ...oldData.payload,
                                    availableMatches: sortMatchesByWager([...availableMatches, transformedMatch])
                                }
                            };
                        } else {
                            console.log(`⚠️ Match ${match.matchId} already exists, skipping`);
                        }
                    } else {
                        console.log(`⚠️ Skipping match_created with empty matchId`);
                    }
                } else if (eventType === 'match_updated') {
                    // Determine if match is active or available based on gameStatus
                    const isActiveMatch = match.gameStatus === 'bonez-started';

                    if (isActiveMatch) {
                        // Match is active - should be in activeMatches
                        const activeIndex = activeMatches.findIndex(m => m.matchId === match.matchId);
                        const availableIndex = availableMatches.findIndex(m => m.matchId === match.matchId);

                        if (activeIndex >= 0) {
                            // Update existing active match
                            // console.log(`🔄 Updating active match at index ${activeIndex}: ${match.matchId}`);
                            const updatedActiveMatches = [...activeMatches];
                            updatedActiveMatches[activeIndex] = transformedMatch;
                            return {
                                ...oldData,
                                payload: {
                                    ...oldData.payload,
                                    availableMatches: sortMatchesByWager(availableMatches),
                                    activeMatches: updatedActiveMatches
                                }
                            };
                        } else {
                            // Move from available to active or add as new active match
                            // console.log(`➡️ Moving/Adding to active matches: ${match.matchId}`);
                            const filteredAvailable = availableMatches.filter(m => m.matchId !== match.matchId);
                            return {
                                ...oldData,
                                payload: {
                                    ...oldData.payload,
                                    availableMatches: sortMatchesByWager(filteredAvailable),
                                    activeMatches: [...activeMatches, transformedMatch]
                                }
                            };
                        }
                    } else {
                        // Match is available (unstarted) - should be in availableMatches
                        const matchIndex = availableMatches.findIndex(m => m.matchId === match.matchId);

                        if (matchIndex >= 0) {
                            // Update existing available match
                            // console.log(`🔄 Updating available match at index ${matchIndex}: ${match.matchId}`);
                            const updatedMatches = [...availableMatches];
                            updatedMatches[matchIndex] = transformedMatch;
                            return {
                                ...oldData,
                                payload: {
                                    ...oldData.payload,
                                    availableMatches: sortMatchesByWager(updatedMatches)
                                }
                            };
                        } else {
                            // When adding a new match, remove any existing unstarted matches from the same host
                            // This handles bots that cancel and recreate matches rapidly
                            const filteredMatches = availableMatches.filter(m =>
                                m.label?.hostId !== match.hostId || m.label?.gameStatus === 'bonez-started'
                            );

                            const hadOldMatch = filteredMatches.length < availableMatches.length;
                            if (hadOldMatch) {
                                // console.log(`🔄 Replacing old match from ${match.hostUsername} with new match ${match.matchId}`);
                            } else {
                                // console.log(`➕ Adding new available match: ${match.matchId} (host: ${match.hostUsername})`);
                            }

                            return {
                                ...oldData,
                                payload: {
                                    ...oldData.payload,
                                    availableMatches: sortMatchesByWager([...filteredMatches, transformedMatch])
                                }
                            };
                        }
                    }
                } else if (eventType === 'match_removed') {
                    // Remove match from availableMatches
                    // console.log(`➖ Removing match: ${match.matchId}`);
                    return {
                        ...oldData,
                        payload: {
                            ...oldData.payload,
                            availableMatches: sortMatchesByWager(availableMatches.filter(m => m.matchId !== match.matchId)),
                            activeMatches: activeMatches.filter(m => m.matchId !== match.matchId)
                        }
                    };
                }

                // console.log("⚠️ No cache update applied, returning old data");
                return oldData;
            });

            // console.log("✅ Cache updated successfully");
        };

        eventsCenter.on(PHASER_EVENTS.LOBBY_MATCH_EVENT, handleMatchEvent);

        return () => {
            eventsCenter.off(PHASER_EVENTS.LOBBY_MATCH_EVENT, handleMatchEvent);
        };
    }, [queryClient]);
    // Use to trigger a refresh of the card collection in the lobby table
    const [callRefreshCardCollection, setCallRefreshCardCollection] = useState(false);

    // Events emitted from Phaser
    const setupInternalPhaserEventListeners = () => {
        //Not sure why, but the listener is being added multiple times. This prevents that
        if (eventsCenter.listeners(PHASER_EVENTS.REWARD_COLLECTED).length < 1) {
            eventsCenter.on(PHASER_EVENTS.REWARD_COLLECTED, (payload) => {
                //Reset the timer in the lobby navbar
                getDailyRewardStatus();
                //Update the local bonez and cards
                let tempUserLevels = userLevels;
                for (const [key, value] of Object.entries(payload.reward)) {
                    if (key.startsWith("bonez_")) {
                        if (userLevels) {
                            tempUserLevels.bone += parseInt(key.split("_")[1]);
                            setUserLevels(tempUserLevels);
                        }
                    } else {
                        // Trigger a refresh of the card collection in the lobby table
                        setCallRefreshCardCollection(true);
                    }
                }
            });
        }
        if (eventsCenter.listeners(PHASER_EVENTS.BUY_OPEN_PACK).length < 1) {
            eventsCenter.on(PHASER_EVENTS.BUY_OPEN_PACK, (payload) => {
                if (payload.typeOfPayment.type === "zoom") {
                    //Update Chipz balance
                    setZoomBalance(payload.wallet.zoom);
                } else {
                    //Update bone balance
                    let tempUserLevels = userLevels;
                    tempUserLevels.bone = payload.userLevel[0].value.data.bone;
                    setUserLevels(tempUserLevels);
                }
            });
        }
        if (eventsCenter.listeners(PHASER_EVENTS.BONE_COLLECTED).length < 1) {
            eventsCenter.on(PHASER_EVENTS.BONE_COLLECTED, (payload) => {
                const getUserName = async () => {
                    const userData = await client.getUsers(session, [payload.sender_id]);
                    setBoneActionUsername(userData.users[0].username);
                    setBoneAction("COLLECTED");
                    setShowBoneToast(true);
                }
                getUserName();
            });
        }
        if (eventsCenter.listeners(PHASER_EVENTS.MATCH_RESULT).length < 1) {
            eventsCenter.on(PHASER_EVENTS.MATCH_RESULT, (payload) => {
                //console.log("Match result: ", payload);

                // Store the content components separately
                const resultData = {
                    subject: payload.subject,
                    potWin: payload.content.potWin,
                    type: payload.content.type,
                    // This will be used to determine whether to show emoji or image
                    isChipz: payload.content.type !== "bone"
                };

                setMatchResultText(resultData);
                setShowMatchResultToast(true);

                // For notifications, we can still use text
                const notificationText = payload.subject + ' ' + payload.content.potWin + ' ' +
                    (payload.content.type === "bone" ? "🦴" : "chipz");
                addNotification(notificationText);
            });
        }

        // Safari-safe event listener registration: always remove and re-add
        eventsCenter.off(PHASER_EVENTS.TOURNAMENT_UPDATE);
        eventsCenter.on(PHASER_EVENTS.TOURNAMENT_UPDATE, (payload) => {
            console.log("🏆 Tournament Update received:", payload);
            setTournamentEndedText(payload.subject);
            setShowTournamentToast(true);

            // Check if this is a reward notification for the current user (they are the winner)
            if (payload.content.rewardBones !== undefined && parseInt(payload.content.rewardBones) > 0) {
                // Show reward animation
                setRewardAmount(parseInt(payload.content.rewardBones));
                setRewardCurrency("bone");
                setShowRewardAnimation(true);

                // Play winner sound
                const audio = new Audio('/bonez/sounds/win-day1.mp3');
                audio.play().catch(err => console.error("Error playing winner sound:", err));

                // Update bone balance after animation starts
                setTimeout(() => {
                    setUserLevels(prevLevels => ({
                        ...prevLevels,
                        bone: parseInt(prevLevels?.bone ?? 0) + parseInt(payload.content.rewardBones)
                    }));
                }, 100);
            } else if (payload.content.rewardChipz !== undefined && parseInt(payload.content.rewardChipz) > 0) {
                // Show reward animation for chipz
                setRewardAmount(parseInt(payload.content.rewardChipz));
                setRewardCurrency("chipz");
                setShowRewardAnimation(true);

                // Play winner sound
                const audio = new Audio('/bonez/sounds/win-day1.mp3');
                audio.play().catch(err => console.error("Error playing winner sound:", err));

                // Refresh chipz balance after animation starts
                setTimeout(async () => {
                    try {
                        const account = await client.getAccount(session);
                        setZoomBalance(parseInt(JSON.parse(account.wallet).zoom) || 0);
                    } catch (error) {
                        console.error('Failed to refresh chipz balance:', error);
                    }
                }, 100);
            }
        });
    }

    // Handle reward animation lifecycle
    useEffect(() => {
        if (showRewardAnimation) {
            // Hide animation after it completes (2 seconds)
            const timer = setTimeout(() => {
                setShowRewardAnimation(false);
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [showRewardAnimation]);

    //fetch leaderboards
    const leaderboardsQuery = useQuery({
        queryKey: ["fetchLeaderboards"],
        enabled: !!(client && session), // Only run query if client and session are available
        queryFn: async () => {
            try {
                if (!client || !session) {
                    throw new Error("Client or session not initialized");
                }
                const leaderboards = await client.rpc(session, "getBonezLeaderboards", null);
                return leaderboards;
            } catch (error) {
                console.error("Failed to fetch leaderboards: ", error);
                if (error.status === 401) {
                    sessionTimeoutCheck();
                }
                throw error; // Re-throw to prevent undefined return
            }
        },
        refetchInterval: 30000, //THIS IS VERY INEFFICIENT. REPLACE WITH BROADCAST LISTENER
    });

    //op code listener
    const [player1Data, setPlayer1Data] = useState(null);
    const [player2Data, setPlayer2Data] = useState(null);
    const [showOpenDeckBuilderModal, setShowOpenDeckBuilderModal] = useState(false);
    const [matchStartOnCooldown, setMatchStartOnCooldown] = useState(false);
    const timeoutRef = useRef(null);
    function reconnectToDeckBuilderOrGame(decodedData) {
        if (decodedData.turnTimer) { //reconnect to game screen
            console.log("rejoining game (Lobby)");
            setLeaveChat(true);
            setTimeout(() => {
                setCurrentScreen("game");
            }, 500)
        }
        else { //reconnect to deck builder
            console.log("rejoining deck builder (Lobby)");
            setLeaveChat(true);
            timeoutRef.current = setTimeout(() => { //delay is necessary to leave chat before joining game
                setCurrentScreen("deckBuilder");
            }, 500)
        }
    }
    useEffect(() => {
        if (opCodeData) {
            const decodedData = JSON.parse(new TextDecoder().decode(opCodeData.data));
            switch (opCodeData.op_code) {
                case opCodes.matchStartPlayer1: {
                    if (!matchStartOnCooldown) {
                        // console.log("Match started: ", opCodeData.match_id);
                        setMatchStartOnCooldown(true); //if players join two match listings from the host at the same time, this prevents the host from joining both
                        setTimeout(() => {
                            setMatchStartOnCooldown(false);
                        }, 3000);
                        setLeaveChat(true);
                        setShowMatchAnnouncement(true);
                        setMatchId(decodedData.matchId);
                        setPlayer1Data(null);
                        setPlayer2Data(decodedData);
                        setShowOpenDeckBuilderModal(true);
                        playSound("matchStartSound");
                        timeoutRef.current = setTimeout(() => {
                            setCurrentScreen("deckBuilder");
                        }, 2500);
                    }
                    break;
                }
                case opCodes.matchStartPlayer2: {
                    if (!matchStartOnCooldown) {
                        //console.log("Match started: ", opCodeData.match_id);
                        setMatchStartOnCooldown(true);
                        setTimeout(() => {
                            setMatchStartOnCooldown(false);
                        }, 3000);
                        setLeaveChat(true);
                        setMatchId(decodedData.matchId);
                        setPlayer1Data(decodedData);
                        setPlayer2Data(null);
                        setShowOpenDeckBuilderModal(true);
                        playSound("matchStartSound");
                        timeoutRef.current = setTimeout(() => {
                            setCurrentScreen("deckBuilder");
                        }, 2500);
                        break;
                    }
                }
                case opCodes.rejoinDeckBuilder: {
                    setLeaveChat(true);
                    timeoutRef.current = setTimeout(() => { //delay is necessary to leave chat before joining game
                        setCurrentScreen("deckBuilder");
                    }, 500)
                    break;
                }
                case opCodes.updateDeckBuilderTimer: {
                    setLeaveChat(true);
                    timeoutRef.current = setTimeout(() => { //delay is necessary to leave chat before joining game
                        setCurrentScreen("deckBuilder");
                    }, 500)
                    break;
                }
                case opCodes.opponentDisconnected: {
                    reconnectToDeckBuilderOrGame(decodedData);
                    break;
                }
                case opCodes.opponentReconnected: {
                    reconnectToDeckBuilderOrGame(decodedData);
                    break;
                }
                case opCodes.playerDisconnected: {
                    reconnectToDeckBuilderOrGame(decodedData);
                    break;
                }
                case opCodes.playerReconnected: {
                    reconnectToDeckBuilderOrGame(decodedData);
                    break;
                }
                case opCodes.gameData: { //rejoin game after disconnect
                    console.log("gameData recieved. Rejoining game (Lobby)");
                    setLeaveChat(true);
                    setTimeout(() => {
                        setCurrentScreen("game");
                    }, 500)
                    break;
                }
                case opCodes.waitingMatchStart: {
                    console.log("gameData recieved. Rejoining game (Lobby)");
                    setLeaveChat(true);
                    setTimeout(() => {
                        setCurrentScreen("game");
                    }, 500)
                    break;
                }
                case opCodes.gameDataSpectator: { //joining as a spectator
                    console.log("gameData recieved. Joining game as spectator (Lobby)");
                    setLeaveChat(true);
                    setTimeout(() => {
                        setCurrentScreen("game");
                    }, 500)
                    break;
                }
                case opCodes.illegitimateMatch: {
                    console.log("Illegitimate match op code recieved.");
                    setShowOpenDeckBuilderModal(false);
                    setShowMatchTerminatedModal(true);
                    clearTimeout(timeoutRef.current); //do not redirect to deckBuilder
                    setOpCodeData(null);
                    setPlayer1Data(null);
                    setPlayer2Data(null);
                    setTimeout(() => {
                        setShowMatchTerminatedModal(false);
                    }, 3000);
                    break;
                }
                default: {
                    console.log("Unknown op code (Lobby): ", opCodeData.op_code);
                }
            }
        }
    }, [opCodeData]);

    const [onlineUsers, _setOnlineUsers] = useState([]); //Use this to keep track of current online users, and manage their avatars
    const onlineUsersRef = useRef(onlineUsers);
    const setOnlineUsers = (update) => {
        eventsCenter.emit(PHASER_EVENTS.LOBBY_UPDATE, update);
        onlineUsersRef.current = update;
        _setOnlineUsers(update);
    }

    const [friendsList, setFriendsList] = useState([]);
    useEffect(() => {
        async function fetchFriends() {
            try {
                if (!client || !session) {
                    console.log("Client or session not initialized, skipping friends fetch");
                    return;
                }
                const result = await client.listFriends(session);
                setFriendsList(result.friends);
                //If any pending friend requests, show a notification
                result.friends.map(friend => {
                    if (friend.state === 2) {
                        setFriendRequestPending(true);
                    }
                });
            } catch (error) {
                console.error('Failed to fetch friends list:', error);
                sessionTimeoutCheck();
            }
        }
        fetchFriends();
    }, [session, client]);

    useEffect(() => {
        const onlineFriends = friendsList.filter(friend =>
            onlineUsers.some(onlineUser => onlineUser.user_id === friend.user.id)
        );
        setOnlineFriendsCount(onlineFriends.length);
    }, [friendsList, onlineUsers]); // This effect runs when friendsList or chatRoomUsers changes

    let userAvatars = new Map([]);
    useEffect(() => {
        async function getUserInfo() {
            if (user && user.metadata) {
                try {
                    // Define the order of collections
                    const collectionOrder = [
                        "bone_streaks",
                        "user_levels",
                        "user_notifications",
                        "bonez_matches",
                        "user_tutorials",
                    ];
                    const storage_objects = await client.readStorageObjects(session, {
                        "object_ids": [
                            {
                                "collection": "bone_streaks",
                                "key": "bone_streaks",
                                "user_id": session.user_id
                            }, {
                                "collection": "user_levels",
                                "key": "user_levels",
                                "user_id": session.user_id
                            }, {
                                "collection": "user_notifications",
                                "key": "notifications",
                                "user_id": session.user_id
                            }, {
                                "collection": "bonez_matches",
                                "key": "bonez_matches",
                                "user_id": session.user_id
                            }, {
                                "collection": "user_tutorials",
                                "key": "tutorial",
                                "user_id": session.user_id
                            }
                        ]
                    })
                    //console.log("storage_objects", storage_objects);
                    // Before sorting, we need to access the objects array from the response
                    storage_objects.objects = storage_objects.objects.sort((a, b) => {
                        return (
                            collectionOrder.indexOf(a.collection) -
                            collectionOrder.indexOf(b.collection)
                        );
                    });
                    //console.log("storage_objects sorted", storage_objects);
                    //Determine if we have a bone to collect/send and set notify icon
                    for (const key in storage_objects.objects[0].value.data) {
                        //console.log("key: ", key);
                        if (storage_objects.objects[0].value.data.hasOwnProperty(key)) {
                            const entry = storage_objects.objects[0].value.data[key];
                            //console.log("entry: ", entry);
                            if ((entry.bonePending === 1 || entry.nextBoneTime <= Date.now()) && (entry.total_bones_collect !== 0 && entry.total_bones_sent !== 0 && entry.nextBoneTime !== 0)) { //not the unacceptated friend request
                                //console.log("bone FOUND !");
                                setBoneReady(true);
                                break;
                            }
                        }
                    }
                    //console.log("objects", objects);
                    if (storage_objects.objects[2] !== undefined) {
                        setNotifications(storage_objects.objects[1].value.token !== 'disable'); // checkbox state under settings
                    } else {
                        setNotifications(false);
                    }
                    setUserLevels(storage_objects.objects[1].value.data); // user levels, bones balance

                    const bonezMatches = storage_objects.objects[3].value.data;
                    //console.log("bonezMatches", bonezMatches);
                    if (bonezMatches.currentMatch !== "") { //we are in a match, resume it
                        joinMatch(bonezMatches.currentMatch);
                        return;
                    }

                    if (bonezMatches.opponentIds.length > 0) {
                        const now = Date.now();
                        const penalizedOpps = bonezMatches.opponentIds.filter(opp => opp.penaltyEnds > now);
                        setPenalizedOpponents(penalizedOpps);
                    }

                    //show forfeit penalty cooldown warning to player
                    if (bonezMatches.forfeit_penaltyends > Date.now()) {
                        // Check if we haven't shown this warning in the current session
                        const penaltyWarningShown = sessionStorage.getItem('forfeitPenaltyWarningShown');
                        if (!penaltyWarningShown) {
                            setShowForfeitPenaltyModal(true);
                            sessionStorage.setItem('forfeitPenaltyWarningShown', 'true');
                        }
                    } else {
                        // Clear the warning flag if penalty has expired
                        sessionStorage.removeItem('forfeitPenaltyWarningShown');
                    }

                    //console.log(objects.objects[4].value.welcomeModal)
                    if (storage_objects.objects[4] && storage_objects.objects[4].value.welcomeModal !== true) {
                        setShowWelcomeModal(false);
                    } else {
                        setShowWelcomeModal(true);
                    }

                    const metadata = JSON.parse(user.metadata)
                    if (metadata.metamaskAccounts) setWalletId(metadata.metamaskAccounts[0]);
                    if (user && user.avatar_url) { //profile picture exists
                        setProfilePicture(user.avatar_url)
                    }
                    else { //default panda profile picture
                        setProfilePicture(pandaPfp);
                    }
                    userAvatars.set(user.id, profilePicture);
                    // console.log("userAvatars log in lobby: ", userAvatars) 
                    var account = await client.getAccount(session);
                    setZoomBalance(parseInt(JSON.parse(account.wallet).zoom));

                    setupInternalPhaserEventListeners();
                } catch (error) {
                    console.error("Failed to fetch user info: ", error)
                    // Only call sessionTimeoutCheck for actual authentication errors
                    if (error.code === 16 || error.message?.includes('UNAUTHENTICATED') || error.message?.includes('session') || error.status === 401 || error.status === 403) {
                        sessionTimeoutCheck();
                    }
                    // For 404/500 server errors, just log and continue - don't logout user
                }

            } else {
                setTimeout(() => setLoadedUserData(!loadedUserData), 100);
            }
        }
        getUserInfo();
        return () => {
            eventsCenter.off(PHASER_EVENTS.REWARD_COLLECTED);
            // Clear forfeit penalty warning flag when component unmounts
            sessionStorage.removeItem('forfeitPenaltyWarningShown');
        }
    }, [loadedUserData, user]);

    useEffect(() => {
        let isMounted = true;

        async function updateBalance() {
            try {
                if (!isMounted) return;

                // Add retry logic for storage operations
                let retryCount = 0;
                const maxRetries = 2;
                let objects = null;

                // Check if client and session are available
                if (!client || !session) {
                    console.log("Client or session not initialized, skipping storage read");
                    return;
                }

                while (retryCount <= maxRetries) {
                    try {
                        objects = await client.readStorageObjects(session, {
                            "object_ids": [{
                                "collection": "user_levels",
                                "key": "user_levels",
                                "user_id": session.user_id
                            }]
                        });
                        break; // Success, exit retry loop
                    } catch (storageError) {
                        retryCount++;
                        if (retryCount > maxRetries) {
                            throw storageError; // Re-throw if max retries exceeded
                        }

                        // Only retry on server errors (500), not auth errors
                        if (storageError.status === 500 || storageError.message?.includes('Internal Server Error')) {
                            console.log(`Retrying storage read in ${1000 * retryCount}ms... (attempt ${retryCount}/${maxRetries})`);
                            await new Promise(resolve => setTimeout(resolve, 1000 * retryCount));
                        } else {
                            throw storageError; // Don't retry auth or other errors
                        }
                    }
                }

                if (objects && objects.objects && objects.objects.length > 0) {
                    setUserLevels(objects.objects[0].value.data);
                }

                try {
                    var account = await client.getAccount(session);
                    setZoomBalance(parseInt(JSON.parse(account.wallet).zoom) || 0);
                } catch (accountError) {
                    console.error('Failed to fetch account:', accountError);
                    setZoomBalance(0); // Set default balance on error
                }
            } catch (error) {
                console.error('Failed to fetch user data:', error);
                if (isMounted) {
                    // Only call sessionTimeoutCheck for actual authentication errors
                    if (error.code === 16 || error.message?.includes('UNAUTHENTICATED') || error.message?.includes('session') || error.status === 401 || error.status === 403) {
                        sessionTimeoutCheck();
                    }
                    // For 404/500 server errors, just log and continue - don't logout user
                    // Note: userLevels is already initialized with defaults, so no need to set here
                    // The component will gracefully show default values until data loads
                }
            }
        } updateBalance();
        return () => {
            isMounted = false;
        }
    }, [isBalanceUpdated]);

    const [showFeedback, setShowFeedback] = useState(false);

    const handleShowFeedback = () => setShowFeedback(true);
    const handleCloseFeedback = () => setShowFeedback(false);

    const [activeGames, setActiveGames] = useState("-");
    const [availableGames, setAvailableGames] = useState("-");
    const [inLobby, setInLobby] = useState("-");
    const [inLobbyFriends, setInLobbyFriends] = useState("0");
    const [inGame, setInGame] = useState("-");
    const [spectating, setSpectating] = useState("-");
    const [loadingSpectate, setLoadingSpectate] = useState(null); // Track which match is loading

    useEffect(() => {
        function countSpectators(activeMatches) {
            if (!activeMatches || !Array.isArray(activeMatches)) {
                return 0;
            }
            let spectatorCount = 0;
            activeMatches.forEach((match) => {
                if (match?.label?.spectatorCount) {
                    spectatorCount += match.label.spectatorCount;
                }
            })
            return spectatorCount;
        }

        if (availableMatchesQuery.isSuccess && availableMatchesQuery.data?.payload) {
            const activeMatches = availableMatchesQuery.data.payload.activeMatches;
            const availableMatches = availableMatchesQuery.data.payload.availableMatches;

            // Safely get lengths with defaults
            const activeMatchesLength = Array.isArray(activeMatches) ? activeMatches.length : 0;
            const availableMatchesLength = availableMatches && typeof availableMatches === 'object' ? Object.keys(availableMatches).length : 0;

            setActiveGames(activeMatchesLength);
            setAvailableGames(availableMatchesLength);
            setInLobby(parseInt(onlineUsersRef.current?.length ?? 0));
            setInLobbyFriends(onlineFriendsCount);
            setInGame(activeMatchesLength * 2);
            setSpectating(countSpectators(activeMatches));
        }

    }, [onlineUsersRef.current, availableMatchesQuery.isSuccess && availableMatchesQuery.data?.payload?.availableMatches, availableMatchesQuery.isSuccess && availableMatchesQuery.data?.payload?.activeMatches, onlineFriendsCount]);

    const [showServerNotifications, setShowServerNotifications] = useState(true);

    // Function to add a new notification
    const addNotification = (message) => {
        // Generate a unique ID for each notification
        const id = Date.now();

        // Make sure notifications is an array before using spread
        const currentNotifications = Array.isArray(notifications) ? notifications : [];

        setNotifications([...currentNotifications, { id, message }]);

        // Optional: Auto-dismiss after a timeout
        setTimeout(() => {
            removeNotification(id);
        }, 3000);
    };

    // Function to remove a notification
    const removeNotification = (id) => {
        setNotifications(prev => {
            // Ensure prev is an array before filtering
            if (!Array.isArray(prev)) return [];
            return prev.filter(notification => notification.id !== id);
        });
    };

    return (
        <div className="lobby-container">
            <ToastContainer
                position={'top-end'} // Move to top-right for better visibility
                style={{ zIndex: 9999, marginTop: '70px' }} // Higher z-index and spacing from top
            >
                {/* Tournament Toast - Gold Celebration Theme */}
                <Toast
                    show={showTournamentToast}
                    onClose={() => setShowTournamentToast(false)}
                    key={"tournamentToast"}
                    delay={6000}
                    autohide
                    style={{
                        minWidth: '350px',
                        background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
                        border: '3px solid #FFD700',
                        boxShadow: '0 8px 24px rgba(255, 215, 0, 0.4), 0 0 20px rgba(255, 215, 0, 0.3)',
                        borderRadius: '12px',
                        animation: 'slideInRight 0.5s ease-out'
                    }}
                >
                    <Toast.Header style={{
                        background: 'rgba(255, 255, 255, 0.95)',
                        borderBottom: '2px solid #FFD700',
                        fontWeight: 'bold'
                    }}>
                        <span style={{ fontSize: '24px', marginRight: '8px' }}>🏆</span>
                        <strong className="me-auto" style={{ fontSize: '18px', color: '#B8860B' }}>Tournament Ended!</strong>
                    </Toast.Header>
                    <Toast.Body style={{
                        padding: '20px',
                        color: '#000',
                        fontSize: '16px',
                        fontWeight: '600',
                        textAlign: 'center',
                        textShadow: '1px 1px 2px rgba(255,255,255,0.8)'
                    }}>
                        <div style={{ fontSize: '20px', marginBottom: '8px' }}>🎉 {tournamentEndedText} 🎉</div>
                    </Toast.Body>
                </Toast>

                {/* Cannot Join Match Toast - Modern Error Theme */}
                <Toast
                    onClose={() => setCannotJoinMatchToast(false)}
                    show={showCannotJoinMatchToast}
                    key={"CannotJoinMatch"}
                    delay={4000}
                    autohide
                    style={{
                        minWidth: '350px',
                        background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                        border: '2px solid #bd2130',
                        boxShadow: '0 6px 20px rgba(220, 53, 69, 0.4)',
                        borderRadius: '12px'
                    }}
                >
                    <Toast.Header style={{
                        background: 'rgba(255, 255, 255, 0.95)',
                        borderBottom: '2px solid #dc3545',
                        fontWeight: 'bold'
                    }}>
                        <span style={{ fontSize: '20px', marginRight: '8px' }}>⚠️</span>
                        <strong className="me-auto" style={{ fontSize: '16px', color: '#dc3545' }}>Cannot Join Match</strong>
                    </Toast.Header>
                    <Toast.Body style={{
                        padding: '16px',
                        color: '#fff',
                        fontSize: '14px',
                        lineHeight: '1.5'
                    }}>
                        Spectators may only join after the game has started
                    </Toast.Body>
                </Toast>

                {/* Bone Toast - Playful Friend Theme */}
                <Toast
                    onClose={() => setShowBoneToast(false)}
                    show={showBoneToast}
                    key={"boneToast"}
                    delay={4000}
                    autohide
                    style={{
                        minWidth: '350px',
                        background: 'linear-gradient(135deg, #20c997 0%, #17a2b8 100%)',
                        border: '2px solid #17a2b8',
                        boxShadow: '0 6px 20px rgba(23, 162, 184, 0.3)',
                        borderRadius: '12px'
                    }}
                >
                    <Toast.Header style={{
                        background: 'rgba(255, 255, 255, 0.95)',
                        borderBottom: '2px solid #17a2b8',
                        fontWeight: 'bold'
                    }}>
                        <span style={{ fontSize: '20px', marginRight: '8px' }}>👥</span>
                        <strong className="me-auto" style={{ fontSize: '16px', color: '#17a2b8' }}>Friend Activity</strong>
                    </Toast.Header>
                    <Toast.Body style={{
                        padding: '16px',
                        color: '#fff',
                        fontSize: '16px',
                        fontWeight: '500',
                        textAlign: 'center'
                    }}>
                        <div style={{ fontSize: '32px', marginBottom: '4px' }}>🦴</div>
                        <div>Bone {boneAction} by <strong>{boneActionUsername}</strong>!</div>
                    </Toast.Body>
                </Toast>

                {/* Match Result Toast - Victory Celebration Theme */}
                <Toast
                    onClose={() => setShowMatchResultToast(false)}
                    show={showMatchResultToast}
                    key={"matchResultToast"}
                    delay={5000}
                    autohide
                    className="match-result-toast"
                    style={{
                        minWidth: '380px',
                        background: 'linear-gradient(135deg, #28a745 0%, #218838 100%)',
                        border: '3px solid #28a745',
                        boxShadow: '0 8px 24px rgba(40, 167, 69, 0.4), 0 0 20px rgba(40, 167, 69, 0.2)',
                        borderRadius: '12px'
                    }}
                >
                    <Toast.Header closeButton={true} style={{
                        background: 'rgba(255, 255, 255, 0.95)',
                        borderBottom: '2px solid #28a745',
                        fontWeight: 'bold'
                    }}>
                        <span style={{ fontSize: '20px', marginRight: '8px' }}>🎮</span>
                        <strong className="me-auto" style={{ fontSize: '16px', color: '#28a745' }}>Match Result</strong>
                    </Toast.Header>
                    <Toast.Body style={{
                        padding: '20px',
                        color: '#fff',
                        textAlign: 'center'
                    }}>
                        {typeof matchResultText === 'object' ? (
                            <>
                                <div style={{ fontSize: '20px', marginBottom: '8px', fontWeight: '600', textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>
                                    {matchResultText.subject}
                                </div>
                                <div style={{
                                    fontSize: '28px',
                                    fontWeight: 'bold',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                                    marginBottom: '8px'
                                }}>
                                    {parseInt(matchResultText.potWin).toLocaleString()}{' '}
                                    {matchResultText.isChipz ? (
                                        <img
                                            src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                            style={{ width: '24px', height: '24px', verticalAlign: 'middle' }}
                                            alt="chipz"
                                        />
                                    ) : (
                                        '🦴'
                                    )}
                                </div>
                                <div style={{ fontSize: '24px' }}>🎉</div>
                            </>
                        ) : (
                            matchResultText
                        )}
                    </Toast.Body>
                </Toast>
            </ToastContainer>
            <DailyBonusPhaser
                setShow={setShowDailyBonusModal}
                show={showDailyBonusModal}
                notifications={notifications}
                setNotifications={setParentNotifications}
                centered
            />
            <Modal show={isShowingPwaModal} centered>
                <PwaModal isSafari={isSafari} isChrome={isChrome} isOtherAndroid={isOtherAndroid} />
            </Modal>
            <Modal show={!isShowingPwaModal && isShowingLandscapeModal} centered>
                <LandscapeModal />
            </Modal>
            <CreateGameModal
                showModal={showCreateModal}
                setShowModal={setShowCreateModal}
                createGame={createGame}
                wagerType={wagerType}
                setWagerType={setWagerType}
                potAmount={potAmount}
                setPotAmount={setPotAmount}
                zoomBalance={zoomBalance}
                bonezBalance={(userLevels?.bone ?? 0).toLocaleString()}
            />
            <CreateShopModal
                showShopModal={showShopModal}
                setShowShopModal={setShowShopModal}
                setShowSuccessModal={setShowSuccessModal}
                setSuccessPackage={setSuccessPackage}
                setZoomBalance={setZoomBalance}
            />
            <CreateSuccessModal
                showSuccessModal={showSucessModal}
                setShowSuccessModal={setShowSuccessModal}
                successPackage={successPackage}
                setSuccessPackage={setSuccessPackage}
            />
            <InsufficientChipzJoinModal
                showModal={showInsufficientChipzModal}
                setShowModal={setShowInsufficientChipzModal}
                requiredAmount={requiredChipzAmount}
                wagerType={insufficientWagerType}
            />
            <OpenDeckBuilderModal
                showModal={showOpenDeckBuilderModal}
                setShowModal={setShowOpenDeckBuilderModal}
                player1Data={player1Data}
                player2Data={player2Data}
            />
            <MatchTerminatedModal
                showModal={showMatchTerminatedModal}
                setShowModal={setShowMatchTerminatedModal}
            />
            <WelcomeModal
                showModal={showWelcomeModal}
                setShowModal={setShowWelcomeModal}
                walletId={walletId}
            />
            <ForfeitPenaltyModal
                show={showForfeitPenaltyModal}
                onHide={() => setShowForfeitPenaltyModal(false)}
            />
            <SessionExpiryModal
                show={showSessionExpiryModal}
                onExtend={handleExtendSession}
                onDismiss={handleDismissSessionWarning}
                minutesRemaining={sessionMinutesRemaining}
                isExtending={isExtendingSession}
            />

            <Container fluid>
                <Navbar className="taskbar" style={{ zIndex: 0 }}>
                    <Container fluid style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                        <Row className="flex-nowrap" style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                            <Col xs="auto" sm="auto" lg="auto" xl="3" xxl="auto" style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                                {zoomBalance === 0 && (
                                    <img src="/bonez/images/notify.png" title="Purchase Coinz" className="notification-icon-chipz" alt="Notification" />
                                )}
                                <div
                                    className="chipz-button-container"
                                    ref={chipzButtonRef}
                                    onClick={(e) => {
                                        playSound("clickSound");
                                        setShowShopModal(true);
                                    }}>
                                    <img
                                        className="icon-chipz"
                                        title="Zoombies Chipz"
                                        src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                        alt="Chipz icon"
                                    />
                                    <span className="container-body-text chipz-amount" style={{ color: "#00D1FF", marginLeft: "8%", display: "contents" }}>
                                        &nbsp;{zoomBalance ? zoomBalance.toLocaleString() : '0'}
                                    </span>
                                </div>
                                {/* Tournament Reward Animation - Chipz */}
                                {showRewardAnimation && rewardCurrency === "chipz" && (
                                    <div className="tournament-reward-animation chipz-reward">
                                        <span style={{ color: "#00D1FF", fontWeight: 'bold', fontSize: '20px' }}>
                                            +{rewardAmount.toLocaleString()}
                                        </span>
                                        <img
                                            className="icon-chipz"
                                            title="Zoombies Chipz"
                                            src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                            alt="Chipz icon"
                                            style={{ width: '20px', height: '20px', marginLeft: '4px' }}
                                        />
                                    </div>
                                )}
                            </Col>
                            <Col xs="2" sm="2" lg="2" xl="2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'relative' }}>
                                {(userLevels?.bone ?? 0) === 0 && (
                                    <img src="/bonez/images/notify.png" title="Invite friends for bones" className="notification-icon-bonez" alt="Notification" />
                                )}
                                <div
                                    className="bonez-button-container"
                                    ref={inviteButtonRef}
                                    onClick={(e) => {
                                        playSound("clickSound");
                                        setIsInviteBarActive(!isInviteBarActive);
                                    }}
                                >
                                    <img
                                        className="icon-bonez"
                                        title="Zoombies Bonez"
                                        alt=""
                                        src={bonezIcon}
                                    />
                                    <span className="container-body-text bone-amount" style={{ marginLeft: "5%", display: "contents" }}>
                                        &nbsp;{(userLevels?.bone ?? 0).toLocaleString()}
                                    </span>
                                </div>
                                {/* Tournament Reward Animation - Bonez */}
                                {showRewardAnimation && rewardCurrency === "bone" && (
                                    <div className="tournament-reward-animation bonez-reward">
                                        <span style={{ color: "#fff", fontWeight: 'bold', fontSize: '20px' }}>
                                            +{rewardAmount.toLocaleString()}
                                        </span>
                                        <span style={{ fontSize: '20px', marginLeft: '4px' }}>🦴</span>
                                    </div>
                                )}
                            </Col>
                            <Col xs="3" sm="1" lg="2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <div className="xp-container">
                                    <img
                                        className="icon-xp"
                                        title="XP"
                                        alt=""
                                        src={xpIcon}
                                    />
                                    <span className="container-body-text xp-amount" style={{ color: "#FFC350", marginLeft: "5%" }}>
                                        {(userLevels?.xp ?? 0).toLocaleString()}
                                    </span>
                                </div>
                            </Col>
                            <Col xs="2" sm="2" lg="1">
                                <img src="/bonez/images/feedback_icon.png" title="Feedback" width="30%" alt="Feedback" onClick={handleShowFeedback} />
                            </Col>
                            <Col xs="auto" sm="3" lg="1" style={{ display: 'flex', alignItems: 'center', minWidth: '90px', flex: '1 2 auto' }}>
                                <button
                                    className={`button create-game-button-taskbar ${(gamesCreated > 2 || isLoadingMatches) ? "button-disabled" : ""}`}
                                    onClick={(e) => {
                                        playSound("clickSound");
                                        setShowCreateModal(true);
                                        // setShowToast(true);
                                    }}
                                    disabled={gamesCreated > 2 || isLoadingMatches || !socketConnected}
                                >
                                    <audio id="clickSound" className="sound-fx" hidden>
                                        <source src="/bonez/sounds/click.mp3" type="audio/mp3" />
                                        Your browser does not support the audio element.
                                    </audio>
                                    <img
                                        className="image-create-game"
                                        src="https://zoombies.world/images/dapp/green_button_400.webp"
                                        alt=""
                                        style={{ height: "100%" }}
                                    />
                                    <span
                                        className="button-text"
                                    >
                                        {isLoadingMatches ? "CREATING..." : "CREATE MATCH"}
                                    </span>
                                </button>
                            </Col>
                            <Col xs="auto" sm="2" md="2" lg="2">
                                <Row>
                                    <Col sm="5" md="3" lg="2" xl="1" xxl="1"></Col>
                                    <Col sm="2" md="3" lg="7" xl="5" xxl="5">
                                        <button
                                            ref={shopButtonRef}
                                            className="shop-button"
                                            style={{ textAlign: 'end' }}
                                            onClick={(e) => {
                                                playSound("clickSound");
                                                setShowDailyBonusModal(true);
                                            }}
                                        >
                                            <img
                                                className="image-shop"
                                                title="Daily Bonus"
                                                src={dailybonusimage}
                                                alt="Daily Bonus icon"
                                            />
                                        </button>
                                    </Col>
                                    <Col sm="2" md="3" lg="3" xl="auto" xxl="3">
                                        <h1
                                            className="container-body-text"
                                            style={{ textAlign: 'center' }}
                                        >
                                            {dailyRewardTimeLabel}
                                        </h1>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs="auto" sm="2" md="2" lg="auto" style={{ display: 'flex', alignItems: 'center', minWidth: '20px', flex: '1 2 auto' }}>
                                <button
                                    ref={shopButtonRef}
                                    className="shop-button"
                                    onClick={(e) => {
                                        playSound("clickSound");
                                        setIsShopBarActive(!isShopBarActive);
                                    }}
                                >
                                    <img
                                        className="image-shop"
                                        title="Shop"
                                        src={shopIcon}
                                        alt="Shop"
                                    />
                                </button>
                            </Col>
                            <Col xs="auto" sm="2" md="2" lg="auto" style={{ display: 'flex', alignItems: 'center', minWidth: '20px', flex: '1 2 auto' }}>
                                <button
                                    ref={inviteButtonRef}
                                    className="invite-button"
                                    onClick={(e) => {
                                        playSound("clickSound");
                                        setIsInviteBarActive(!isInviteBarActive);
                                    }}
                                >
                                    <img
                                        className="image-invite"
                                        title="Invite"
                                        src={heartIcon}
                                        alt="Invite"
                                    />
                                </button>
                            </Col>
                            <Col xs="1" sm="2" md="2" lg="auto" style={{ display: 'flex', alignItems: 'center', minWidth: '20px', flex: '1 2 auto' }}>
                                <button
                                    ref={settingsButtonRef}
                                    className={`settings-button ${isSettingsBarActive ? 'active' : ''}`}
                                    onClick={(e) => {
                                        playSound("clickSound");
                                        setIsSettingsBarActive(!isSettingsBarActive);
                                    }}
                                >
                                    <img
                                        className="image-settings"
                                        title="Settings"
                                        src={settingsIcon}
                                        alt="Settings"
                                    />
                                </button>
                            </Col>
                            <Col xs="1" sm="2" md="2" lg="auto" style={{ display: 'flex', alignItems: 'center', minWidth: '20px', flex: '1 2 auto' }}>
                                <button
                                    ref={infoButtonRef}
                                    className="info-button"
                                    onClick={(e) => {
                                        playSound("clickSound");
                                        setIsInfoBarActive(!isInfoBarActive);
                                    }}
                                >
                                    <img
                                        className="image-info"
                                        title="Info"
                                        src={infoIcon}
                                        alt="Info"
                                    />
                                </button>
                            </Col>
                            <Col xs="auto" sm="2" md="2" lg="auto" style={{ display: 'flex', alignItems: 'center', minWidth: '20px', flex: '1 2 auto' }}>
                                {pwaDownloaded &&
                                    <button
                                        className="leave-button"
                                        onClick={(e) => {
                                            playSound("clickSound");
                                            window.open('', '_self', '');
                                            window.close();
                                        }}
                                    >
                                        <img
                                            className="image-leave"
                                            title="Leave Game"
                                            src={leaveGameButton}
                                            alt="Leave Game"
                                        />
                                    </button>
                                }
                                {isLoadSceneVisible && <DailyBonusPhaser setIsLoadSceneVisible={setIsLoadSceneVisible} />}
                            </Col>
                        </Row>
                    </Container>
                    <audio id="clickSound" className="sound-fx" hidden>
                        <source src="/bonez/sounds/click.mp3" type="audio/mp3" />
                    </audio>
                </Navbar>

                <Offcanvas show={isSettingsBarActive} onHide={() => setIsSettingsBarActive(false)} placement="end" style={{ backgroundColor: '#1B3A5D' }}>
                    <Offcanvas.Header className="offcanvas-header-container" closeButton style={{ justifyContent: 'center' }}>
                        <Offcanvas.Title
                            style={{
                                fontFamily: 'Truculenta, sans-serif',
                                fontSize: '40px',
                                fontWeight: 'bold',
                                color: 'white',
                            }}
                        >
                            Settings
                        </Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <span className="container-body-text" style={{ fontSize: "30px", color: "#00D1FF", marginTop: "5.5%" }}>Music</span>
                            <input
                                className="volume-slider"
                                type="range"
                                min="0"
                                max="100"
                                value={musicVolume}
                                onChange={e => setMusicVolume(e.target.value)}
                                style={musicSliderBackground}
                            />

                            <span className="container-body-text" style={{ fontSize: "30px", color: "#00D1FF", marginTop: "6.5%" }}>Sound FX</span>
                            <input
                                className="volume-slider mb-5"
                                type="range"
                                min="0"
                                max="100"
                                value={soundVolume}
                                onChange={e => setSoundVolume(e.target.value)}
                                style={soundSliderBackground}
                            />
                            <Row className="mt-5">
                                {!walletId ?
                                    <Col>
                                        <Button variant="danger" size="lg" onClick={redirectToBridge} style={{ fontSize: "2rem", padding: "0.5rem 1rem" }}>
                                            Connect WEB3&nbsp;<img src={metamaskIcon} alt="Metamask Icon" style={{ width: "40px", height: "40px" }} />
                                        </Button>
                                    </Col>
                                    :
                                    <Col>
                                        <Row className="container-body-text" style={{ fontSize: "30px", color: "#00D1FF" }}>
                                            <Col>
                                                <span>
                                                    <img src={metamaskIcon} alt="Metamask Icon" style={{ width: "40px", height: "40px" }} />Web3 Connected
                                                </span>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <span style={{ color: '#FFFFFF', fontSize: '1.5rem' }}>
                                                    {walletId ? `${walletId.slice(0, 5)}...${walletId.slice(-5)}` : ''}
                                                </span>
                                            </Col>
                                            <Col className="d-none d-lg-block">
                                                <Button variant="primary" size="sm" onClick={redirectToBridge} style={{ fontSize: "1.2rem" }}>
                                                    Buy Chipz
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                }
                            </Row>
                            <span className="container-body-text" style={{ fontSize: "30px", color: "#00D1FF", marginTop: "5rem" }}>Web Notifications</span>
                            <span style={{ color: '#FFFFFF', fontSize: '1.5rem' }}>Important notices from friends</span>
                            <Row style={{ marginTop: "1rem" }}>
                                <Col>
                                    <Form.Check
                                        type="switch"
                                        id="notifications"
                                        name="notifications"
                                        value="notifications"
                                        label="ON"
                                        checked={notifications}
                                        onChange={e => {
                                            setNotifications(e.target.checked);
                                            if (e.target.checked) {
                                                requestBrowserNotificationPermission(true);
                                            } else {
                                                requestBrowserNotificationPermission(false);
                                            }
                                        }}
                                        style={{ marginTop: "5%", width: "32px", height: "32px", fontSize: "2rem", color: "#ffffff" }}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </Offcanvas.Body>
                </Offcanvas>

                <Offcanvas show={isShopBarActive} onHide={closeShopNav} placement="end">
                    <Offcanvas.Body className="canvasshop" style={{ backgroundColor: '#001f3f', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '400px', height: '400px' }}>
                        {isShopActive ? (
                            <Shop
                                toggleShopContent={toggleShopContent}
                                setShowSuccessModal={setShowSuccessModal}
                                setSuccessPackage={setSuccessPackage}
                                setZoomBalance={setZoomBalance}
                            />
                        ) : (
                            <>
                                {!isCoinActive && !isBonezActive &&
                                    <CardNav
                                        toggleBalanceUpdated={toggleBalanceUpdated} toggleBonezContent={toggleBonezContent}
                                        toggleCoinContent={toggleCoinContent}
                                        userBones={userLevels?.bone ?? 0}
                                        zoomBalance={zoomBalance}

                                        wagerType={wagerType}
                                        potAmount={potAmount}
                                        leaveMatch={leaveMatch}
                                        availableMatchesQuery={availableMatchesQuery}
                                        isCancelling={isCancelling}
                                    />
                                }
                                {isCoinActive && <Insufficientcoin toggleCoinContent={toggleCoinContent} />}
                                {isBonezActive && <Insufficientbonez toggleBonezContent={toggleBonezContent} toggleInviteContent={toggleInviteContent} />}
                                {isInviteBarActive && (<InviteNav isInviteBarActive={isInviteBarActive} setIsInviteBarActive={setIsInviteBarActive} />)}
                            </>
                        )}
                    </Offcanvas.Body>
                </Offcanvas>

                <Offcanvas
                    show={showLobbyList}
                    onHide={() => {
                        setShowLobbyList(false);
                        window.Phaser.PlayerInfo = false;
                        window.Phaser.MyInfo = false;
                        window.Phaser.SpectatorInfo = false;
                        window.Phaser.SpectatorId = null;
                    }}
                    placement="start"
                >

                    <Offcanvas.Body
                        className="canvasshop"
                        style={{
                            backgroundColor: ' #000022',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '400px',
                            height: 'auto',
                        }}
                    >
                        <LobbyList showing={showLobbyList} />
                    </Offcanvas.Body>
                </Offcanvas>

                <InviteNav
                    isInviteBarActive={isInviteBarActive}
                    setIsInviteBarActive={setIsInviteBarActive}
                />

                <InfoNav
                    isInfoBarActive={isInfoBarActive}
                    setIsInfoBarActive={setIsInfoBarActive}
                />

                <audio id="dailyRewardSound" className="sound-fx" hidden>
                    <source src="/bonez/sounds/select_bonez_zoombies.mp3" type="audio/mp3" />
                </audio>


                <Row className="main-body-container" style={{ height: "100%" }}>
                    <Col lg={3} sm={3}>
                        <Row className="mt-n4">
                            <Col lg={8} sm={6}>
                                <Collapse in={true} dimension="width">
                                    <div className="bonez-header">
                                        <Image
                                            src="https://zoombies.world/images/bonez/bonez_logo.png"
                                            className="bonez-logo"
                                            alt=""
                                        />
                                    </div>
                                </Collapse>
                            </Col>
                            <Col lg={2} sm={6}>
                                {!pwaDownloaded &&
                                    <img
                                        src="/bonez/images/full-screen-icon.png"
                                        onClick={toggleFullscreen}
                                        alt=""
                                        className="full-screen"
                                        style={{ marginLeft: "5.5%", position: 'relative', zIndex: 1000 }}
                                    />
                                }
                            </Col>
                        </Row>
                        <div className="whole-container players-online d-none d-lg-block" ref={lobbyListRef} onClick={redirectToBridge}>
                            <h1 className="container-body-text">
                                {!walletId ?
                                    <Button variant="success" size="lg" style={{ fontSize: "2rem", padding: "0.5rem 1rem" }}>
                                        Connect WEB3&nbsp;<img src={metamaskIcon} alt="Metamask Icon" style={{ width: "40px", height: "40px" }} />
                                    </Button>
                                    :
                                    <span style={{ color: "#00F955" }}>
                                        Web3 {walletId ? `${walletId.slice(0, 5)}...${walletId.slice(-5)} Connected` : ''}
                                    </span>
                                }
                            </h1>
                            <p className="container-body-text">
                                <span className="">Buy <img
                                    className="icon-chipz"
                                    title="Zoombies Chipz"
                                    src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                    alt="Chipz icon"
                                    style={{ width: "32px", height: "32px", marginRight: "1px", marginBottom: "4px" }}
                                /> Chipz</span><br />
                                Play&nbsp;
                                <img
                                    className="icon-chipz"
                                    title="Zoombies Chipz"
                                    src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                    alt="Chipz icon"
                                    style={{ width: "32px", height: "32px", marginRight: "1px", marginBottom: "4px" }}
                                />&nbsp;Win Prizes !
                            </p>
                            <p className="container-body-text top"></p>
                        </div>
                        <div className="whole-container players-online d-block d-lg-none">
                            <p className="container-body-text">
                                <span className="">Open on Desktop to<br />Buy <img
                                    className="icon-chipz"
                                    title="Zoombies Chipz"
                                    src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                    alt="Chipz icon"
                                    style={{ width: "18px", height: "18px", marginRight: "1px", marginBottom: "2px" }}
                                /> Chipz</span>
                            </p>
                        </div>
                        <div className="whole-container card-panel mt-1 mb-1">
                            <Row xs={2} md={2} lg={2}>
                                <Col>
                                    <div className="container-body-text card-panel-text">
                                        POWER CARD 5 PACK
                                    </div>
                                    <button className="button chipz-panel" onClick={handleCoin} style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
                                        <img className="green-button-cards" src="https://zoombies.world/images/dapp/green_button_400.webp" alt="" />

                                        {/* <span className="button-text chipz-panel" style={{ display: "flex", alignItems: "center", justifyContent: "center", marginLeft: "5px", textAlign: "center" }}> 
                                            <img
                                                className="icon"
                                                title="Zoombies Chipz"
                                                src="https://zoombies.world/images/bonez/bonez_chipz_credit.webp"
                                                style={{ width: "40%", height: "90%", marginRight: "5px", marginBottom: "7%", marginLeft:"-20px" }}
                                                alt="Chipz icon"
                                            />
                                            10,000
                                        </span>  */}
                                        <span className="button-text">OPEN NOW</span>
                                    </button>
                                </Col>
                                <Col>
                                    <img src={shopnavicon2} className="lobby-card-display" alt="NFT Power Card Panel" />
                                </Col>
                            </Row>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                            {/* {isLoadingMatches && (   */}
                            <ToastContainer
                                className="p-3"
                                position={'top-start'} // Set the position here
                                style={{ zIndex: 1 }}
                            >
                                <Toast onClose={() => setShowToast(false)} show={showToast} className="d-inline-block m-1" bg={'success'} style={{ maxWidth: '400px', minHeight: '15px', fontSize: '14px' }} delay={3000} autohide>
                                    <Toast.Header>
                                        <strong className="me-auto">Creating...</strong>
                                    </Toast.Header>
                                    <Toast.Body className={`text-white ${'success' === 'Dark' && 'font-weight-bold'}`} style={{ textAlign: 'left' }}>
                                        Match being created...please wait
                                    </Toast.Body>
                                </Toast>
                            </ToastContainer>
                            {/* )}  */}
                        </div>
                        <div className="whole-container tournament-panel" style={{ backgroundColor: "#ed59aa" }}>
                            <ImageFader />
                        </div>
                    </Col>
                    <Col style={{ textAlign: 'center' }} lg={6} sm={6}>
                        <LobbyTable
                            joinMatch={joinMatch}
                            leaveMatch={leaveMatch}
                            loadingSpectate={loadingSpectate}
                            setLoadingSpectate={setLoadingSpectate}
                            availableMatchesQuery={availableMatchesQuery}
                            leaderboardsQuery={leaderboardsQuery}
                            isLoadingMatches={isLoadingMatches}
                            isCancelling={isCancelling}
                            spectating={spectating}
                            showModal={showCreateModal}
                            setShowModal={setShowCreateModal}
                            isInviteBarActive={isInviteBarActive}
                            setIsInviteBarActive={setIsInviteBarActive}
                            createGame={createGame}
                            wagerType={wagerType}
                            setWagerType={setWagerType}
                            potAmount={potAmount}
                            setPotAmount={setPotAmount}
                            zoomBalance={zoomBalance ?? 0}
                            bonezBalance={(userLevels?.bone ?? 0).toLocaleString()}
                            gamesCreated={gamesCreated}
                            callRefreshCardCollection={callRefreshCardCollection}
                            penalizedOpponents={penalizedOpponents}
                        />
                        <audio id="matchStartSound" className="sound-fx" hidden>
                            <source src="/bonez/sounds/match-started.mp3" type="audio/mp3" />
                        </audio>
                    </Col>
                    <Col lg={3} sm={3}>
                        <div className="page-fit-container">
                            <div className="whole-container page-fit-stretchable" style={{ display: "flex", flexDirection: "column", backgroundColor: "rgba(22, 27, 47, 0.7)" }}>
                                <ChatRoom
                                    user={user}
                                    profilePicture={profilePicture}
                                    joinMatch={joinMatch}
                                    availableMatchesQuery={availableMatchesQuery}
                                    spectating={spectating}
                                    loadingSpectate={loadingSpectate}
                                    setLoadingSpectate={setLoadingSpectate}
                                    leaveChat={leaveChat}
                                    setLeaveChat={setLeaveChat}
                                    joinChat={joinChat}
                                    setJoinChat={setJoinChat}
                                    onlineUsers={onlineUsers}
                                    onlineUsersRef={onlineUsersRef}
                                    setOnlineUsers={setOnlineUsers}
                                    client={client}
                                    session={session}
                                    userAvatars={userAvatars}
                                    showMatchAnnouncement={showMatchAnnouncement}
                                    player2Data={player2Data}
                                    wagerType={wagerType}
                                    opCodeData={opCodeData}
                                    setOpCodeData={setOpCodeData}
                                    friendRequestPending={friendRequestPending}
                                    boneReady={boneReady}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>

            <Overlay
                target={lobbyListRef.current}
                placement="right"
            >
                Click to see the list of online users
            </Overlay>
            <NotificationPopover
                notificationsEnabled={notifications}
                setNotifications={setParentNotifications}
            >
            </NotificationPopover>
            <FeedbackForm show={showFeedback} onClose={handleCloseFeedback} />
            <ServerNotifications
                show={showServerNotifications}
                onHide={() => setShowServerNotifications(false)}
                client={client}
                session={session}
                sessionTimeoutCheck={sessionTimeoutCheck}
                setShowServerNotifications={setShowServerNotifications}
            />
        </div >
    );
}    